import { Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

export const ThankYouMessage = () => {
  const { t } = useResource();

  return (
    <Stack gap={7} alignItems="center">
      <Typography maxWidth={360} variant="h6" fontWeight={600}>
        {t(Resources.Merchant.InitiateDetail.ThankYouMessage)}
      </Typography>
    </Stack>
  );
};
